module.exports = __webpack_public_path__ + "img/Proxelia_120X35.07d517e1.png";